import {
  obtenerTokenStorage,
  agregarTokenStorage,
} from '@/servicios/sessionStorage.js'

const state = {
  token: obtenerTokenStorage || '',
  estaAutenticado: false,
}

const getters = {
  obtenerToken(state) {
    return state.token
  },
  estaAutenticado(state) {
    return state.estaAutenticado
  },
}

const mutations = {
  actualizarToken(state, payload) {
    state.token = payload.token
    agregarTokenStorage(payload.token)
  },
  actualizarEstaAutenticado(state) {
    state.estaAutenticado = true
  },
}

const actions = {
  actualizarToken(context, payload) {
    context.commit('actualizarToken', payload)
    context.commit('actualizarEstaAutenticado')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
